__turbopack_context__.v({
  "bg-aqua": "o-info-teaser-module-scss-module__sWjWCq__bg-aqua",
  "bg-background-gray": "o-info-teaser-module-scss-module__sWjWCq__bg-background-gray",
  "bg-berry": "o-info-teaser-module-scss-module__sWjWCq__bg-berry",
  "bg-black": "o-info-teaser-module-scss-module__sWjWCq__bg-black",
  "bg-dark-aqua": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-aqua",
  "bg-dark-berry": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-berry",
  "bg-dark-gray": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-gray",
  "bg-dark-green": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-green",
  "bg-dark-moss": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-moss",
  "bg-dark-orange": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-orange",
  "bg-dark-red": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-red",
  "bg-dark-smoke": "o-info-teaser-module-scss-module__sWjWCq__bg-dark-smoke",
  "bg-faded-aqua": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-aqua",
  "bg-faded-berry": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-berry",
  "bg-faded-gray": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-gray",
  "bg-faded-green": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-green",
  "bg-faded-moss": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-moss",
  "bg-faded-red": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-red",
  "bg-faded-smoke": "o-info-teaser-module-scss-module__sWjWCq__bg-faded-smoke",
  "bg-gray": "o-info-teaser-module-scss-module__sWjWCq__bg-gray",
  "bg-green": "o-info-teaser-module-scss-module__sWjWCq__bg-green",
  "bg-light-aqua": "o-info-teaser-module-scss-module__sWjWCq__bg-light-aqua",
  "bg-light-berry": "o-info-teaser-module-scss-module__sWjWCq__bg-light-berry",
  "bg-light-gray": "o-info-teaser-module-scss-module__sWjWCq__bg-light-gray",
  "bg-light-green": "o-info-teaser-module-scss-module__sWjWCq__bg-light-green",
  "bg-light-moss": "o-info-teaser-module-scss-module__sWjWCq__bg-light-moss",
  "bg-light-red": "o-info-teaser-module-scss-module__sWjWCq__bg-light-red",
  "bg-light-smoke": "o-info-teaser-module-scss-module__sWjWCq__bg-light-smoke",
  "bg-moss": "o-info-teaser-module-scss-module__sWjWCq__bg-moss",
  "bg-orange": "o-info-teaser-module-scss-module__sWjWCq__bg-orange",
  "bg-red": "o-info-teaser-module-scss-module__sWjWCq__bg-red",
  "bg-smoke": "o-info-teaser-module-scss-module__sWjWCq__bg-smoke",
  "bg-white": "o-info-teaser-module-scss-module__sWjWCq__bg-white",
  "container": "o-info-teaser-module-scss-module__sWjWCq__container",
  "content": "o-info-teaser-module-scss-module__sWjWCq__content",
  "icon": "o-info-teaser-module-scss-module__sWjWCq__icon",
  "icon-color-Aqua": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Aqua",
  "icon-color-BackgroundGray": "o-info-teaser-module-scss-module__sWjWCq__icon-color-BackgroundGray",
  "icon-color-Berry": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Berry",
  "icon-color-Black": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Black",
  "icon-color-DarkAqua": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkAqua",
  "icon-color-DarkBerry": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkBerry",
  "icon-color-DarkGray": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkGray",
  "icon-color-DarkGreen": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkGreen",
  "icon-color-DarkMoss": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkMoss",
  "icon-color-DarkOrange": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkOrange",
  "icon-color-DarkRed": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkRed",
  "icon-color-DarkSmoke": "o-info-teaser-module-scss-module__sWjWCq__icon-color-DarkSmoke",
  "icon-color-FadedAqua": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedAqua",
  "icon-color-FadedBerry": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedBerry",
  "icon-color-FadedGray": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedGray",
  "icon-color-FadedGreen": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedGreen",
  "icon-color-FadedMoss": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedMoss",
  "icon-color-FadedRed": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedRed",
  "icon-color-FadedSmoke": "o-info-teaser-module-scss-module__sWjWCq__icon-color-FadedSmoke",
  "icon-color-Gray": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Gray",
  "icon-color-Green": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Green",
  "icon-color-LightAqua": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightAqua",
  "icon-color-LightBerry": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightBerry",
  "icon-color-LightGray": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightGray",
  "icon-color-LightGreen": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightGreen",
  "icon-color-LightMoss": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightMoss",
  "icon-color-LightRed": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightRed",
  "icon-color-LightSmoke": "o-info-teaser-module-scss-module__sWjWCq__icon-color-LightSmoke",
  "icon-color-Moss": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Moss",
  "icon-color-Orange": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Orange",
  "icon-color-Red": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Red",
  "icon-color-Smoke": "o-info-teaser-module-scss-module__sWjWCq__icon-color-Smoke",
  "icon-color-White": "o-info-teaser-module-scss-module__sWjWCq__icon-color-White",
  "placeholder": "o-info-teaser-module-scss-module__sWjWCq__placeholder",
  "wrapper": "o-info-teaser-module-scss-module__sWjWCq__wrapper",
  "wrapper-boxed": "o-info-teaser-module-scss-module__sWjWCq__wrapper-boxed",
});
